"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = exports.Size = void 0;
var _GlobalSize = _interopRequireDefault(require("../type-tools/GlobalSize"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["DEFAULT"] = "default";
  Variant["FAVORITE"] = "favorite";
  Variant["FIXED"] = "fixed";
  Variant["DESTRUCTIVE"] = "destructive";
  Variant["INVERSE"] = "inverse";
  Variant["HIGHLIGHT"] = "highlight";
  return Variant;
}(Variant || {});
var Size = exports.Size = function (Size) {
  Size[Size["MEDIUM"] = _GlobalSize["default"].MEDIUM] = "MEDIUM";
  Size[Size["SMALL"] = _GlobalSize["default"].SMALL] = "SMALL";
  Size[Size["LARGE"] = _GlobalSize["default"].LARGE] = "LARGE";
  return Size;
}(Size || {});